import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const AdminAddUserIcon = (props: IconProps) => (
  <Icon width="16px" height="16px" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M8.707 5.333a2.666 2.666 0 1 0-5.334 0 2.666 2.666 0 1 0 5.334 0Zm-1.334 0c0 .733-.6 1.333-1.333 1.333s-1.333-.6-1.333-1.333S5.307 4 6.04 4s1.333.6 1.333 1.333ZM.707 12v1.333h10.666V12c0-1.774-3.553-2.667-5.333-2.667-1.78 0-5.333.893-5.333 2.667Zm1.333 0c.133-.473 2.2-1.334 4-1.334 1.793 0 3.853.854 4 1.334h-8Zm11.333-2V8h2V6.667h-2v-2H12.04v2h-2V8h2v2h1.333Z" />
  </Icon>
);
export default memo(AdminAddUserIcon);
